// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8f9142a9","749":"fa6eff92","903":"c8bbaef0"}[chunkId] + ".chunk.js";
};